<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:createModal="{}"
        >
          <i class="far fa-plus"></i> Lead
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Leads.</h2>

      <leads-list-filters v-model="params" />

      <c-data-list class="list-leads" :items="leads" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-3">
            <p>Customer</p>
          </div>
          <div class="col-12 col-lg">
            <p>Message</p>
          </div>
          <div class="col-6 col-lg-auto lead-col-assigned">
            <p>Assigned</p>
          </div>
          <div class="col-6 col-lg-auto lead-col-dates">
            <p>Dates</p>
          </div>
          <div class="col-6 col-lg-auto lead-col-status text-end">
            <p>Stage</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <leads-list-item :lead="slotProps.item" @stage-changed="leadStageChanged" />
        </template>
        <template v-slot:empty>
          No leads to show.
        </template>
      </c-data-list>
    </div>

    <lead-modal
      ref="createModal"
      title="Create Lead"
      :lead="newLead"
      @saved="leadCreated"
    />
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import { mapState, mapActions } from 'vuex'
import LeadsListItem from './LeadsListItem'
import LeadsListFilters from './LeadsListFilters'
import LeadModal from './LeadModal'
import LeadModel from './../../models/lead.js'

export default {
  components: {
    LeadsListItem,
    LeadsListFilters,
    LeadModal
  },

  data () {
    return {
      params: {},
      newLead: new LeadModel(),
      initialLoad: null
    }
  },

  mounted () {
    this.initialLoad = this.getLeads(this.payload)

    this.$watch('payload', async (payload, oldPayload) => {
      if (isEqual(payload, oldPayload)) {
        return
      }

      this.initialLoad = this.getLeads(payload)
    })
  },

  computed: {
    ...mapState('lead', { leads: 'list' }),

    payload () {
      const { stage, ...payload } = this.params

      if (stage && stage !== 'all') {
        payload.stage = stage
      }

      return payload
    }
  },

  methods: {
    ...mapActions('lead', { getLeads: 'getList', getLeadsForNextPage: 'getListForNextPage', removeLead: 'deleteFromLocalToList' }),

    async loadNextPage (done) {
      try {
        await this.initialLoad
        await this.getLeadsForNextPage(this.payload)

        done()
      } catch (error) {
        done(true)
      }
    },

    leadStageChanged (lead) {
      const stage = this.params.stage

      if (stage && stage !== 'all' && lead.stage !== stage) {
        this.removeLead(lead.id)
      }
    },

    leadCreated () {
      this.initialLoad = this.getLeads(this.payload)
    }
  }
}
</script>

<style>
@media (min-width: 992px) {
  .list-leads .lead-col-assigned {
    width: 11rem;
  }

  .list-leads .lead-col-dates {
    width: 7.5rem;
  }

  .list-leads .lead-col-status {
    width: 8.5rem;
  }
}
</style>
